import { render } from "./PanelSeparator.vue?vue&type=template&id=768d7c8a&lang=pug"
import script from "./PanelSeparator.vue?vue&type=script&lang=js"
export * from "./PanelSeparator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__